import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "30vh",
    [theme.breakpoints.down("sm")]: {
      height: "40vh",
    },
    width: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    "& a": {
      color: theme.palette.colors.orange,
    },
  },
  headline: {},
  text: {
    textAlign: "left",
  },
}));

function LightBoxCaptionYoutube(props) {
  const headline = props.headline ? props.headline : false;
  const text = props.text ? props.text : false;
  const children = props.children ? props.children : false;

  useEffect(() => {}, []);

  const classes = useStyles();

  return (
    <Grid className={classes.root} container justifyContent="center">
      {headline && (
        <Grid container item xs={12} justifyContent="center">
          <Grid item xs={12}>
            <Typography
              className={classes.headline}
              variant="h4"
              align="center"
              gutterBottom
            >
              {headline}
            </Typography>
          </Grid>
        </Grid>
      )}
      {text && (
        <Grid container item xs={12} justifyContent="center">
          <Grid item xs={11} sm={10} md={8} lg={6}>
            <Typography className={classes.text} paragraph>
              {text}
            </Typography>
          </Grid>
        </Grid>
      )}
      {children && (
        <Grid container item xs={12} justifyContent="center">
          {children}
        </Grid>
      )}
    </Grid>
  );
}

export default LightBoxCaptionYoutube;
